import styled from 'styled-components';

import {
  blueSphera,
  grayLightSphera,
  graySphera,
  grayDarkSphera,
  yellowSphera,
  whiteSphera,
  grayPlaceholder
} from 'src/utilities/UIStyles/variables/Colors';

import { fadeIn, fadeOut } from 'src/utilities/animations';

export const ModalForgotPassword = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  visibility: ${(props) => (props.showModalForgotPassword ? 'visible' : 'hidden')};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 100;
  animation: ${(props) => (props.showModalForgotPassword ? fadeIn : fadeOut)} 0.5s linear;
  transition: all 0.5s;

  > div {
    width: 40%;
    background-color: ${whiteSphera};
    border-radius: 5px;
    padding-top: 1%;
    padding-bottom: 2.5%;

    > div:nth-child(1) {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding-bottom: 2.5%;
      border-bottom: 1px solid #b7bcc7;

      > h3 {
        font-size: 1.5vw;
        color: ${graySphera};
        width: 90%;
        padding-left: 5%;
      }

      > figure {
        width: 25px;
        height: 25px;
        cursor: pointer;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > div:nth-child(1) {
        > h3 {
        }

        > figure {
          > img {
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    > div {
      width: 90%;
      padding-top: 5%;
      padding-bottom: 5%;

      > div:nth-child(1) {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        padding-bottom: 5%;
        border-bottom: 1px solid #b7bcc7;

        > h3 {
          font-size: 4.5vw;
        }

        > figure {
          > img {
          }
        }
      }
    }
  }
`;

export const ChangePassword = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 2.5%;
  padding-left: 5%;

  > p:nth-child(1) {
    font-size: 1.2vw;
    color: ${graySphera};
    width: 80%;
    margin-bottom: 5%;

    > span {
      color: ${blueSphera};
      font-weight: bold;
    }
  }

  > input:nth-child(2) {
    font-size: 1.2vw;
    width: 80%;
    margin-bottom: 8%;
    padding: 1% 0 1% 2.5%;
    border: none;
    border-bottom: 1px solid #8c96aa;

    &::placeholder {
      color: ${grayLightSphera};
    }
  }

  > button {
    color: ${(props) => (props.isAvailable ? grayDarkSphera : whiteSphera)};
    font-weight: bold;
    font-size: 1.2vw;
    text-align: center;
    width: 40%;
    height: 50px;
    margin: auto;
    border: none;
    border-radius: 5px;
    background-color: ${(props) => (props.isAvailable ? yellowSphera : grayPlaceholder)};
    cursor: ${(props) => (props.isAvailable ? 'pointer' : 'not-allowed')};
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > p:nth-child(1) {
      > span {
      }
    }

    > input:nth-child(2) {
      &::placeholder {
      }
    }

    > button {
    }
  }

  @media (max-width: 600px) {
    padding-top: 5%;

    > p:nth-child(1) {
      font-size: 4.2vw;
      width: 95%;

      > span {
      }
    }

    > input:nth-child(2) {
      font-size: 4.2vw;
      width: 95%;

      &::placeholder {
      }
    }

    > button {
      font-size: 4.2vw;
      width: 95%;
      height: 50px;
      margin: 0;
    }
  }
`;

export const SentEmail = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 2.5%;
  padding-left: 5%;

  > p:nth-child(1) {
    font-size: 1.2vw;
    width: 85%;
    margin-bottom: 5%;

    > span {
      color: ${blueSphera};
      font-weight: bold;
    }
  }

  > a:nth-child(2) {
    color: ${grayDarkSphera};
    font-weight: bold;
    font-size: 1.2vw;
    text-decoration: none;
    text-align: center;
    line-height: 50px;
    width: 35%;
    height: 50px;
    margin: auto;
    border: none;
    border-radius: 5px;
    background-color: ${yellowSphera};
    cursor: pointer;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > p:nth-child(1) {
      > span {
      }
    }

    > a:nth-child(2) {
    }
  }

  @media (max-width: 600px) {
    padding-top: 5%;

    > p:nth-child(1) {
      font-size: 4.2vw;
      width: 95%;

      > span {
      }
    }

    > a:nth-child(2) {
      font-size: 4.2vw;
      width: 95%;
    }
  }
`;
